import { render, staticRenderFns } from "./discussionTab.vue?vue&type=template&id=0c136720&scoped=true&"
import script from "./discussionTab.vue?vue&type=script&lang=js&"
export * from "./discussionTab.vue?vue&type=script&lang=js&"
import style0 from "./discussionTab.vue?vue&type=style&index=0&id=0c136720&scoped=true&lang=css&"
import style1 from "./discussionTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c136720",
  null
  
)

export default component.exports